import { PropsWithChildren } from 'react';
import OnboardingNav from './OnboardingNav';


const OnboardingLayout = ({children}: PropsWithChildren) => {
  return (
    <div className="flex h-full">
      <OnboardingNav />
      <section className="flex flex-1 flex-col items-center p-5 bg-[url('images/onboarding-pattern.svg')] bg-no-repeat bg-top">
        {children}
      </section>
    </div>
  )
}
export default OnboardingLayout;